
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[shortname]",
      function () {
        return require("private-next-pages/[shortname].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[shortname]"])
      });
    }
  